module.exports = __webpack_public_path__ + "img/mlh_honor_3.8096d460.png";